var render = function render(){var _vm=this,_c=_vm._self._c;return _c('arrow-selection-item',{staticClass:"source-type-selection-item",attrs:{"imageSource":_vm.imageSource,"text":_vm.text},on:{"click":_vm.raiseClickEvent}})
}
var staticRenderFns = []

export { render, staticRenderFns }